<template>
  <ModalDialog @close="hideOverlay">
    <div class="text-center sm:text-left">
      <h2 class="font-heading-title mb-4">{{ content.heading }}</h2>
      <div
        v-if="content.bullets && content.bullets.length"
        class="mb-6 font-body-text"
        tag="div"
      >
        <ul>
          <li v-for="bullet in content.bullets" :key="bullet" class="mb-4">
            {{ bullet }}
          </li>
        </ul>
      </div>

      <BaseButton
        class="mb-2"
        :label="content.buttonText"
        size="large"
        @click="handleClick"
      />
      <p class="font-body-caption w-52 max-w-full mx-auto sm:mx-0">
        We'll help uncover HR compliance gaps within your business
      </p>
    </div>
    <img
      class="abandonment-content__desktop-image absolute bottom-0 right"
      :style="{ 'max-height': '300px', 'z-index': '-1' }"
      alt=""
      src="~/assets/images/splash/purple.png"
    />
  </ModalDialog>
</template>

<script>
import { BaseButton, ModalDialog } from '@bambeehr/pollen';
import { useRouter } from '@nuxtjs/composition-api';
import Analytics from '@/services/Analytics';
import useAbandonmentOverlay from '@/modules/AbandonmentOverlay/hooks/useAbandonmentOverlay';

export default {
  components: { BaseButton, ModalDialog },
  setup() {
    const router = useRouter();
    const { content, hideOverlay } = useAbandonmentOverlay();

    const handleClick = () => {
      Analytics.track('clicked-overlay-schedule-button', {
        variant: content.value.variant,
      });
      router.push('/registration/company-size');
    };

    return {
      content,
      handleClick,
      hideOverlay,
    };
  },
};
</script>
